import React, {Component} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import BurgerBuilder from './BurgerBuilder/BurgerBuilder';
import Order from './BurgerBuilder/Order/Order';
import Checkout from './BurgerBuilder/Order/Checkout/Checkout';
import Header from './Header/Header';
import Auth from './Auth/Auth';
import {connect} from 'react-redux'
import {authCheck} from '../redux/AuthActionCreaters';
import Logout from './Auth/Logout';

const mapStateToProps=state=>{
    return{
        token:state.token,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        authCheck: () => {
            dispatch(authCheck())
        }
    }
}

class Main extends Component{

    componentDidMount(){
        this.props.authCheck();
    }
    render(){
        console.log(this.props);
        let route=null;
        if(this.props.token===null){
            route=(
                <Switch>
                    <Route path="/auth" exact component={Auth}/>
                    <Redirect to="/auth"/>
                </Switch>
            )
        }
        else{
            route=(<Switch>
                <Route path="/" exact component={BurgerBuilder}/>
                <Route path="/order" component={Order}/>
                <Route path="/checkout" component={Checkout}/>
                <Route path="/logout" component={Logout} />
                <Redirect to="/" />
            </Switch>)
        }
        return(
            <div>
                <Header/>
                {route}
            </div>
        )
    }
    
}
export default connect(mapStateToProps,mapDispatchToProps)(Main);